import React from 'react'
import { useI18n } from '../../i18n'
import LifecycleBadge from './LifecycleBadge'
import styles from '../../styles/components/assets/AssetsRiskCompliance.module.scss'
import type { GrcSummaryRow } from '../../services/informationSystemComplianceApi'

export function readinessBadgeClass(status: string | null | undefined): string {
  const s = String(status || 'UNKNOWN').toUpperCase()
  if (s === 'READY') return styles.readinessReady
  if (s === 'READY_FOR_REVIEW' || s === 'IN_REVIEW') return styles.readinessReview
  if (s === 'NOT_READY' || s === 'BLOCKED') return styles.readinessNotReady
  return styles.readinessUnknown
}

export function SectionCell({
  label,
  children,
  first,
}: {
  label: string
  children: React.ReactNode
  first?: boolean
}) {
  return (
    <div className={`${styles.rowSection} ${first ? styles.rowSectionFirst : ''}`.trim()}>
      <p className={styles.sectionHeader}>{label}</p>
      {children}
    </div>
  )
}

export function MetricDisplay({
  value,
  sub,
  unknownLabel,
}: {
  value: string | number | null | undefined
  sub?: string | null
  unknownLabel: string
}) {
  const empty =
    value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
  if (empty) {
    return <p className={styles.metricUnknown}>{unknownLabel}</p>
  }
  return (
    <>
      <p className={styles.metricValue}>{value}</p>
      {sub ? <p className={styles.metricSub}>{sub}</p> : null}
    </>
  )
}

export function SystemIdentityCell({ row }: { row: GrcSummaryRow }) {
  const { t } = useI18n()
  const status = row.readinessStatus || 'UNKNOWN'

  return (
    <div className={`${styles.systemIdentity} ${styles.rowSectionFirst}`}>
      <div className={styles.identityHeader}>
        <h4 className={styles.systemName} title={row.name}>
          {row.name}
        </h4>
        <LifecycleBadge status={row.lifecycleStatus} />
        <span className={`${styles.readinessBadge} ${readinessBadgeClass(status)}`}>
          {t(`assets.grc.readiness.${status}`, status)}
        </span>
      </div>
      {row.criticality ? (
        <p className={styles.systemMeta}>{row.criticality}</p>
      ) : null}
    </div>
  )
}
